import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

class Portforlioinsert extends Component {
    render() {
        return (
            <div>
                <Container className="py-4">
                    <Row>
                        <Col className="text-center">
                            <h2>Our Portfolio</h2>
                            <h4>A selection of sites we've worked with</h4>
                        </Col>
                    </Row>
                </Container>
                <div className="lrss-bg">
                    <Container className="py-5">
                        <Row className="align-items-center bg-dark-transparent p-4">
                            <Col className="text-white">
                                <h2>Louise Rands' Star Services</h2>
                                <h5>Mental Health and Wellbeing Services in Koonoomoo</h5>
                                <a href="https://louiserandsstarservices.com.au/" target="_blank" rel="noopener noreferrer"><Button>Visit the website</Button></a>                      
                            </Col>
                            <Col className="text-white">
                                <p>We worked closely with the client to produce a simple, 4 page website that is SEO friendly, and loads fast. Louise Rands' Star Services is a small business in the remote town of Koonoomoo, specialising in providing quality services, including Neuro-Linguistic Programming, holistic massage, animal therapy and horse rider training to her community.</p>
                            </Col>
                        </Row>
                        <Row className="align-items-center bg-dark-transparent">
                            
                        </Row>
                    </Container>
                </div>
                <div className="lrss-bg">
                    <Container className="py-5">
                        <Row className="align-items-center bg-dark-transparent p-4">
                            <Col className="text-white">
                                <h2>Student Handouts</h2>
                                <h5>Free Educational Materials for K-12 Teachers and Students of All Subjects</h5>
                                <a href="https://studenthandouts.com/" target="_blank" rel="noopener noreferrer"><Button>Visit the website</Button></a>                      
                            </Col>
                            <Col className="text-white">
                                <p>Student Handouts needed a better web host to serve their website. Stormdragon Designs worked closely with the developer, creating a custom hosting service that balanced the existing workflow of the website, with advanced hosting and performance tweaks in order to allow over 1.5 million requests be served every week, as quickly as possible.</p>
                            </Col>
                        </Row>
                        <Row className="align-items-center bg-dark-transparent">
                            
                        </Row>
                    </Container>
                </div>
            </div>
        )
    }
}

export default Portforlioinsert; 


// WEBPACK FOOTER //
// ./src/components/Portfolioinsert.js